export const rooms = {
    "en": [
        {value: 'Family Room', label: 'Family Room'},
        {value: 'Living Room', label: 'Living Room'},
        {value: 'Dining Room', label: 'Dining Room'},
        {value: 'Kitchen', label: 'Kitchen'},
        {value: 'Main Bedroom', label: 'Main Bedroom'},
        {value: 'Bedroom 1', label: 'Bedroom 1'},
        {value: 'Bedroom 2', label: 'Bedroom 2'},
        {value: 'Bedroom 3', label: 'Bedroom 3'},
        {value: 'Bedroom 4', label: 'Bedroom 4'},
        {value: 'Closet', label: 'Closet'},
        {value: 'Main Bathroom', label: 'Main Bathroom'},
        {value: 'Bathroom 1', label: 'Bathroom 1'},
        {value: 'Bathroom 2', label: 'Bathroom 2'},
        {value: 'Bathroom 3', label: 'Bathroom 3'},
        {value: 'Bathroom 4', label: 'Bathroom 4'},
        {value: 'Office', label: 'Office'},
        {value: 'Entry', label: 'Entry'},
        {value: 'Hall', label: 'Hall'},
        {value: 'Laundry', label: 'Laundry'},
        {value: 'Nursery', label: 'Nursery'},
        {value: 'Waiting Room', label: 'Waiting Room'},
        {value: 'Storage Room', label: 'Storage Room'},
        {value: 'Guest Bedroom', label: 'Guest Bedroom'},
        {value: 'Guest Room', label: 'Guest Room'},
        {value: 'Playroom', label: 'Playroom'},
        {value: "Kid's Room 1", label: "Kid's Room 1"},
        {value: "Kid's Room 2", label: "Kid's Room 2"},
        {value: "Kid's Room 3", label: "Kid's Room 3"},
        {value: "Kid's Room 4", label: "Kid's Room 4"},
        {value: 'Gym', label: 'Gym'},
        {value: 'Other', label: 'Other'}
    ],
    "fa": [
        {value: 'Family Room', label: 'اتاق نشیمن'},
        {value: 'Living Room', label: 'اتاق پذیرای/سالن'},
        {value: 'Dining Room', label: 'اتاق غذاخوری'},
        {value: 'Kitchen', label: 'آشپزخانه'},
        {value: 'Main Bedroom', label: 'اتاق خواب اصلی/مستر'},
        {value: 'Bedroom 1', label: 'اتاق خواب ۱'},
        {value: 'Bedroom 2', label: 'اتاق خواب ۲'},
        {value: 'Bedroom 3', label: 'اتاق خواب ۳'},
        {value: 'Bedroom 4', label: 'اتاق خواب ۴'},
        {value: 'Closet', label: 'کمد لباس'},
        {value: 'Main Bathroom', label: 'سرویس بهداشتی اصلی'},
        {value: 'Bathroom 1', label: 'سرویس بهداشتی ۱'},
        {value: 'Bathroom 2', label: 'سرویس بهداشتی ۲'},
        {value: 'Bathroom 3', label: 'سرویس بهداشتی ۳'},
        {value: 'Bathroom 4', label: 'سرویس بهداشتی ۴'},
        {value: 'Office', label: 'دفتر'},
        {value: 'Entry', label: 'ورودی'},
        {value: 'Hall', label: 'هال'},
        {value: 'Laundry', label: 'خشکشویی'},
        {value: 'Nursery', label: 'مهد کودک'},
        {value: 'Waiting Room', label: 'اتاق انتظار'},
        {value: 'Storage Room', label: 'انبار'},
        {value: 'Guest Bedroom', label: 'اتاق خواب مهمان'},
        {value: 'Guest Room', label: 'اتاق مهمان'},
        {value: 'Playroom', label: 'اتاق بازی'},
        {value: "Kid's Room 1", label: 'اتاق کودک ۱'},
        {value: "Kid's Room 2", label: 'اتاق کودک ۲'},
        {value: "Kid's Room 3", label: 'اتاق کودک ۳'},
        {value: "Kid's Room 4", label: 'اتاق کودک ۴'},
        {value: 'Gym', label: 'باشگاه'},
        {value: 'Other', label: 'دیگر'}
    ]
};

export const motorChannels = {
    "en": [
        {value: '0', label: '0 (All Products)', disabled: true},
        {value: '1', label: '1'},
        {value: '2', label: '2'},
        {value: '3', label: '3'},
        {value: '4', label: '4'},
        {value: '5', label: '5'},
        {value: '6', label: '6'},
        {value: '7', label: '7'},
        {value: '8', label: '8'},
        {value: '9', label: '9'},
        {value: '10', label: '10'},
        {value: '11', label: '11'},
        {value: '12', label: '12'},
        {value: '13', label: '13'},
        {value: '14', label: '14'},
        {value: '15', label: '15'}
    ],
    "fa": [
        {value: '0', label: '۰ (همه پرده ها)'},
        {value: '1', label: '۱'},
        {value: '2', label: '۲'},
        {value: '3', label: '۳'},
        {value: '4', label: '۴'},
        {value: '5', label: '۵'},
        {value: '6', label: '۶'},
        {value: '7', label: '۷'},
        {value: '8', label: '۸'},
        {value: '9', label: '۹'},
        {value: '10', label: '۱۰'},
        {value: '11', label: '۱۱'},
        {value: '12', label: '۱۲'},
        {value: '13', label: '۱۳'},
        {value: '14', label: '۱۴'},
        {value: '15', label: '۱۵'}
    ],
    
};

export const MotorPosition = {
  en: [{ value: "Left", label: "Left" }, { value: "Right", label: "Right" }],
  fa: [{ value: "Left", label: "چپ" }, { value: "Right", label: "راست" }],
};

export const privacyLayerSelect = {
  en: [
    { value: "I Have 25mm Rod", label: "25mm Rod" },
    { value: "I Have 28mm Rod", label: "28mm Rod" },
    { value: "I Have Standard Track", label: "Standard Track", disabled: true },
    { value: "I Have Track With Cord Draw", label: "Track With Cord Draw", disabled: true },
    { value: "I Have Motorized Track", label: "Motorized Track", disabled: true },
    { value: "I Have Others", label: "Others" },
  ],
  fa: [
    { value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
    { value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
    { value: "I Have Standard Track", label: "ریل استاندارد", disabled: true },
    { value: "I Have Track With Cord Draw", label: "ریل اتوماتیک", disabled: true },
    { value: "I Have Motorized Track", label: "موتور برقی", disabled: true },
    { value: "I Have Others", label: "سایر" },
  ],
};

export const privacyLayerSelect2 = {
  en: [
    { value: "I Have 25mm Rod", label: "25mm Rod", disabled: true },
    { value: "I Have 28mm Rod", label: "28mm Rod", disabled: true },
    { value: "I Have Standard Track", label: "Standard Track" },
    { value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
    { value: "I Have Motorized Track", label: "Motorized Track" },
    { value: "I Have Others", label: "Others" },
  ],
  fa: [
    { value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری", disabled: true },
    { value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری", disabled: true },
    { value: "I Have Standard Track", label: "ریل استاندارد" },
    { value: "I Have Track With Cord Draw", label: "ریل اتوماتیک" },
    { value: "I Have Motorized Track", label: "موتور برقی" },
    { value: "I Have Others", label: "سایر" },
  ],
};

export const privacyLayerSelect3 = {
  en: [
    { value: "I Have 25mm Rod", label: "25mm Rod" },
    { value: "I Have 28mm Rod", label: "28mm Rod" },
    { value: "I Have Standard Track", label: "Standard Track" },
    { value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
    { value: "I Have Motorized Track", label: "Motorized Track" },
    { value: "I Have Others", label: "Others" },
  ],
  fa: [
    { value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
    { value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
    { value: "I Have Standard Track", label: "ریل استاندارد" },
    { value: "I Have Track With Cord Draw", label: "ریل اتوماتیک" },
    { value: "I Have Motorized Track", label: "موتور برقی" },
    { value: "I Have Others", label: "سایر" },
  ],
};
